import { account, aduio, aduio_video, dept_ry, dept, location, meet, message, record, video, server } from '@/config';
import '@/css/scooper.video.css';
import sha256_digest from '@/lib/sha256';
import { loadJson, initCometd, initVideo } from '@/common-request';
export const dologin = function (username, password, sip) {
  let net = account.loginNet;
  let url = (sip || server) + net.url;
  return new Promise((resolve, reject) => {
    loadJson(url, {
      accUsername: username,
      accPassword: sha256_digest(password)
    }, function (ret) {
      if (ret.code == 0) {
        let token = ret.data;
        let connectUrl = '/dispatch-web/api/conn/connectionByToken';
        loadJson((sip || server) + connectUrl, {
          token
        }, function (ret1) {
          if (ret1.code == 0) {
            console.log("登录连接完成", ret1.code);
            resolve(ret1);
          } else {
            console.log("登录连接失败", ret1.code);
            reject(ret1.code);
          }
        }, '', 'POST'); //启动心跳保持
        // if(heartTime) {
        //     clearInterval(heartTime);
        // }
        // setInterval(keepHeart, 15000);

        resolve(token);
        /**
         * 初始化操作：
         * 1.启动心跳保持
         * 2.加载账号信息
         * 3.初始化推送cometd
         */
      } else {
        reject("登录失败", ret.code);
      }
    }, '', net.method);
  });
};
export const doLogout = function (token, sip) {
  let net = account.logoutNet;
  let url = (sip || server) + net.url;
  return new Promise((resolve, reject) => {
    if (token) {
      loadJson(url, {
        token
      }, function (ret) {
        if (ret.code == 0) {
          let token = ret.data;
          resolve();
          /**
           * 清除心跳保持(全局定时器)
           */
        } else {
          reject("登出失败", ret.code);
        }
      }, '', net.method);
    } else {
      reject("token值无效", -1);
    }
  });
};
export const keepHeart = function (token, sip) {
  let net = account.heartBeatNet;
  let url = (sip || server) + net.url;
  return () => loadJson(url, {
    token
  }, function (ret) {
    if (ret.code == 0) {
      console.log("心跳设置完成", ret.code);
    } else {
      console.log("心跳设置失败", ret.code);
    }
  }, '', net.method);
};
export { initCometd, initVideo, sha256_digest };
export const accountOp = sip => {
  let server_ = sip || server;
  return {
    add: function (param) {
      let net = account.saveAccountNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            console.log("账号新增完成", ret.code);
            resolve(ret);
          } else {
            console.log("账号新增失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    update: function (param) {
      let net = account.updateAccountNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            console.log("账号更新完成", ret.code);
            resolve(ret);
          } else {
            console.log("账号更新失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    delete: function (param) {
      let net = account.deleteAccountNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            console.log("账号删除完成", ret.code);
            resolve(ret);
          } else {
            console.log("账号删除失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    updateDeptPerm: function (param) {
      let net = account.updateDeptDataPermission;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            console.log("账号通讯录权限更新完成", ret.code);
            resolve(ret);
          } else {
            console.log("账号通讯录权限更新失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    resetPwd: function (param) {
      let net = account.resetPwdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            console.log("账号密码重置完成", ret.code);
            resolve(ret);
          } else {
            console.log("账号密码重置失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    resetSelfPwd: function (param) {
      let net = account.resetSelfPwdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            console.log("当前账号密码重置完成", ret.code);
            resolve(ret);
          } else {
            console.log("当前账号密码重置失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    list: function (param) {
      let net = account.listAccountNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("账号列表查询失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    listPage: function (param) {
      let net = account.queryAccountNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("账号列表分页查询失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    linkMember: function (param) {
      let net = account.getAccountLinkMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("账号关联部门成员查询失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    info: function (param) {
      let net = account.getAccountDetailNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("账号详情查询失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    }
  };
};
export const aduioOp = sip => {
  let server_ = sip || server;
  return {
    call: function (param) {
      let net = aduio.callNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("语音呼叫失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    answer: function (param) {
      let net = aduio.answerNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("语音呼叫接听失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    hold: function (param) {
      let net = aduio.holdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("保持通话失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    unhold: function (param) {
      let net = aduio.unholdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("取消保持通话失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    transfer: function (param) {
      let net = aduio.transferNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("通话转接失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    retrieve: function (param) {
      let net = aduio.retrieveNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("取消通话转接失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    tripleBreakin: function (param) {
      let net = aduio.tripleBreakinNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("强插失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    tripleHungup: function (param) {
      let net = aduio.tripleHungupNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("强拆失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    tripleMonitor: function (param) {
      let net = aduio.tripleMonitorNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("监听失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    groupNotify: function (param) {
      let net = aduio.groupNotifyNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("组呼通知失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    groupNotifyListPage: function (param) {
      let net = aduio.queryGroupNotifyNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("组呼通知分页查询失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    callListPage: function (param) {
      let net = aduio.queryCallNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("呼叫记录分页查询失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    }
  };
};
export const aduioVideoOp = sip => {
  let server_ = sip || server;
  return {
    callHungup: function (param) {
      let net = aduio_video.callHungupNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("语音或视频拆线/挂断失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    listStatus: function (param) {
      let net = aduio_video.listStatusNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("获取所有号码状态失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    telsStatus: function (param) {
      let net = aduio_video.telsStatusNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("获取指定号码状态失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    telsStatusAssist: function (param) {
      let net = aduio_video.telsStatusAssistNet;
      let urlParamString = '';

      if (net.paramOnUrl) {
        net.paramOnUrl.forEach(key => {
          urlParamString && (urlParamString += '&');
          urlParamString += `${key}=${param[key]}`;
          delete param[key];
        });
      }

      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url + (urlParamString ? '?' + urlParamString : ''), { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("获取指定号码状态辅助接口失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    }
  };
};
export const deptOp = sip => {
  let server_ = sip || server;
  return {
    add: function (param) {
      let net = dept.saveOrgDeptNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("新增部门失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    update: function (param) {
      let net = dept.updateOrgDeptNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("更新部门失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    delete: function (param) {
      let net = dept.deleteOrgDeptNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("删除部门失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    info: function (param) {
      let net = dept.getOrgDeptDetailNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门信息失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    listPage: function (param) {
      let net = dept.queryOrgDeptNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询部门列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    list: function (param) {
      let net = dept.listOrgDeptNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    listFrom: function (param) {
      let net = dept.listDeptByParentNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门下属层级关系失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    path: function (param) {
      let net = dept.findDepartmentPathNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门所在层级的关系路径失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    treeFrom: function (param) {
      let net = dept.listTreeDeptByParentNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门所在树形的关系失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    memberCount: function (param) {
      let net = dept.findDeptMemberCount;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门成员数量", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    changeSort: function (param) {
      let net = dept.changeDeptSortIndexNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("修改部门排序失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    memberList: function (param) {
      let net = dept.listDeptMemberByDeotIdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门成员列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    listAreaCode: function (param) {
      let net = dept.listDeptMemberByDeotIdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询行政区划列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    }
  };
};
export const deptRyOp = sip => {
  let server_ = sip || server;
  return {
    addRyAndAccount: function (param) {
      let net = dept_ry.createRyAndAccount;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("新增部门成员失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    createOnGis: function (param) {
      let net = dept_ry.createOnGis;
      let urlParamString = '';

      if (net.paramOnUrl) {
        net.paramOnUrl.forEach(key => {
          urlParamString && (urlParamString += '&');
          urlParamString += `${key}=${param[key]}`;
          delete param[key];
        });
      }

      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url + (urlParamString ? '?' + urlParamString : ''), { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("创建成员定位到GIS失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method, null, net.contentType);
      });
    },
    add: function (param) {
      let net = dept_ry.saveOrgMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("新增部门成员失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    update: function (param) {
      let net = dept_ry.updateOrgMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("更新部门成员失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    delete: function (param) {
      let net = dept_ry.deleteOrgMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("删除部门成员失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    info: function (param) {
      let net = dept_ry.getOrgMemberDetailNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门成员信息失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    listPage: function (param) {
      let net = dept_ry.queryOrgMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询部门成员失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    list: function (param) {
      let net = dept_ry.listOrgMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门成员列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    findByTel: function (param) {
      let net = dept_ry.findOrgMemberByTelNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("通过关联号码查询部门成员信息失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    path: function (param) {
      let net = dept_ry.findOrgMemberPathNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询部门成员所在层级路径失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    linkAccount: function (param) {
      let net = dept_ry.findAccountByOrgMemberIdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询成员关联账号失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    changeSort: function (param) {
      let net = dept_ry.changeOrgMemberSortIndexNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("修改成员排序失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    listIds: function (param) {
      let net = dept_ry.listOrgMemberByIdsNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (!ret) reject('网络连接问题');else {
            if (ret.code == 0) {
              resolve(ret);
            } else {
              console.log("多id查询成员列表失败", ret.code);
              reject(ret.code);
            }
          }
        }, '', net.method);
      });
    }
  };
};
export const locationOp = sip => {
  let server_ = sip || server;
  return {
    locate: function (param) {
      let net = location.reLocationNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("上报位置信息失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method, {
          headers: net.headers
        });
      });
    },
    trace: function (param) {
      let net = location.listTraceByArgsNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询人员轨迹失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    tracePage: function (param) {
      let net = location.listTraceByArgsPageNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询人员轨迹失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    gisList: function (param) {
      let net = location.listGisTrailNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("获取GIS定位数据失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    locateDeviceByType: function (param) {
      let net = location.listTypeLocationNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (!ret) reject('网络连接问题');else {
            if (ret.code == 0) {
              resolve(ret);
            } else {
              console.log("获取设备信息失败", ret.code);
              reject(ret.code);
            }
          }
        }, '', net.method);
      });
    }
  };
};
export const meetOp = sip => {
  let server_ = sip || server;
  return {
    create: function (param) {
      let net = meet.selectCallNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("发起会议失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    setChairman: function (param) {
      let net = meet.setMeetChairmanNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("设置会场主持人失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    privateTalk: function (param) {
      let net = meet.MeetPrivateTalkNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("设置会场成员单独通话失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    back: function (param) {
      let net = meet.MeetBackToNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("会场成员单独通话后回到会场失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    end: function (param) {
      let net = meet.endMeetNet;
      let async = true;

      if (Object.keys(param).includes('async')) {
        async = param.async;
      }

      if (async) {
        return new Promise((resolve, reject) => {
          loadJson(server_ + net.url, { ...param
          }, function (ret) {
            if (ret.code == 0) {
              resolve(ret);
            } else {
              console.log("结束会议失败", ret.code);
              reject(ret.code);
            }
          }, '', net.method);
        });
      } else {
        // 同步
        delete param.async; // loadJson(server_+net.url, { ...param }, function(ret){
        //   if(ret.code == 0) {
        //     console.log("结束会议成功");
        //   }else{
        //     console.log("结束会议失败", ret.code);
        //   }
        // }, async, net.method);

        return fetch(server_ + net.url, {
          method: net.method,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Sc-Token': param.token
          },
          body: new URLSearchParams(param),
          keepalive: true
        });
      }
    },
    joinVideo: function (param) {
      let net = meet.joinVideoMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("加入视频会议失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    join: function (param) {
      let net = meet.joinMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("加入语音会议失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    createRoom: function (param) {
      let net = meet.createMeetNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("创建会议会场失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    destroyRoom: function (param) {
      let net = meet.destroyMeetNet;
      let async = true;

      if (Object.keys(param).includes('async')) {
        async = param.async;
        delete param.async;
      }

      return fetch(server_ + net.url, {
        method: net.method,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'Sc-Token': param.token
        },
        body: new URLSearchParams(param),
        keepalive: true
      }); // if(async){
      //   return new Promise((resolve, reject) => {
      //     loadJson(server_+net.url, { ...param }, function(ret){
      //       if(ret.code == 0) {
      //         resolve(ret);
      //       }else{
      //         console.log("销毁会议会场失败", ret.code);
      //         reject(ret.code);
      //       }
      //     }, '', net.method);
      //   });
      // }else{
      //   // 同步
      //   delete param.async
      //   loadJson(server_+net.url, { ...param }, function(ret){
      //     if(ret.code == 0) {
      //       console.log("销毁会议会场成功");
      //     }else{
      //       console.log("销毁会议会场失败", ret.code);
      //     }
      //   }, async, net.method);
      // }
    },
    changeMemberStatus: function (param) {
      let net = meet.changeMemeberLevelNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("更改会场会员状态失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    kick: function (param) {
      let net = meet.kickMemberNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("踢出会场会员失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    list: function (param) {
      let net = meet.listMeetsNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询会议列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    info: function (param) {
      let net = meet.getMeetNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询会议信息失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    members: function (param) {
      let net = meet.listMeetMembersNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询与会成员列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    }
  };
};
export const messageOp = sip => {
  let server_ = sip || server;
  return {
    send: function (param) {
      let net = message.sendMsgNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("发送短信失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    listPage: function (param) {
      let net = message.queryMsgSendNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询短信记录失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    info: function (param) {
      let net = message.findMsgSendByIdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询短信信息失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    findBatchResult: function (param) {
      let net = message.findBatchResultNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询某条群发短信的发送状态失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    delete: function (param) {
      let net = message.deleteMsgSendNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("删除短信失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    recvListPage: function (param) {
      let net = message.queryMsgRecvNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询接收短信列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    recvInfo: function (param) {
      let net = message.findMsgRecvByIdNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("查询接收短信信息失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    read: function (param) {
      let net = message.updateRecvStatusNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("阅读接收短信失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    unreadNum: function (param) {
      let net = message.getUnReadRecvNumNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("获取未读短信数量失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    }
  };
};
export const recordOp = sip => {
  let server_ = sip || server;
  return {
    aduioListPage: function (param) {
      let net = record.queryRecordNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询录音记录列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    videoListPage: function (param) {
      let net = record.queryVideoNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询录像记录列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    callRecordListPage: function (param) {
      let net = record.queryCallRecordNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询通话录音录像表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    meetRecordListPage: function (param) {
      let net = record.queryMeetingRecordNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询会议录音录像表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    notifyPageList: function (param) {
      let net = record.queryRecordNotifyNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("分页查询通知音记录列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    uploadNotify: function (param) {
      let net = record.uploadNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("上传通知音失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    download: function (param) {
      let net = record.doDownloadNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("录音录像下载失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    delete: function (param) {
      let net = record.deleteFileNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("录音录像删除失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    }
  };
};
export const videoOp = sip => {
  let server_ = sip || server;
  return {
    facilityList: function (param) {
      let net = video.getFacilityListNet;
      let urlParamString = '';

      if (net.paramOnUrl) {
        net.paramOnUrl.forEach(key => {
          urlParamString && (urlParamString += '&');
          urlParamString += `${key}=${param[key]}`;
          delete param[key];
        });
      }

      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url + (urlParamString ? '?' + urlParamString : ''), { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("获取移动设备列表失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    call: function (param) {
      let net = video.callVideoNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("拨打视频失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    },
    tree: function (param) {
      let net = video.getNodesVideoNet;
      return new Promise((resolve, reject) => {
        loadJson(server_ + net.url, { ...param
        }, function (ret) {
          if (ret.code == 0) {
            resolve(ret);
          } else {
            console.log("加载视频树节点数据失败", ret.code);
            reject(ret.code);
          }
        }, '', net.method);
      });
    }
  };
};
export { account, aduio, aduio_video, dept_ry, dept, location, meet, message, record, video }; //接口相关参数以及返回值，暴露出去可以供开发者查看